import styled from 'styled-components'

export const FormWrapper = styled.div`
  margin-top: -13px;
  margin-left: 20px;
`

export const AlertWrapper = styled.div`
  padding: 20px 20px 0;
`
export const TabsWrapper = styled.div`
  margin-left: 20px;
  margin-bottom: 10px;
`
